import { FormikHelpers } from "formik";
import PhonecentersSysModelForm from "./PhonecentersSysModelForm";
import { useGetPhonecentersSysModel } from "./api/getPhonecentersSysModel";
import { useEditPhonecentersSysModel } from "./api/editPhonecentersSysModel";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditPhonecentersSysModel = ({handleCloseModal, phonecentersSysModelId}: EditPhonecentersSysModelProps)  => {
  const getPhonecentersSysModelQuery = useGetPhonecentersSysModel({phonecentersSysModelId: phonecentersSysModelId})
  const editPhonecentersSysModelMutation = useEditPhonecentersSysModel({data: {}, phonecentersSysModelId});

  const handleSubmit = async (values: IPostEditPhonecentersSysModel, { setSubmitting }: FormikHelpers<IPostEditPhonecentersSysModel>): Promise<void> => {
    try {
      await editPhonecentersSysModelMutation.mutateAsync({
        data: values,
        phonecentersSysModelId: phonecentersSysModelId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getPhonecentersSysModelQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getPhonecentersSysModelQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Μοντέλου.</div>
    )
  }

  return (
    <>
      {!getPhonecentersSysModelQuery.isLoading && getPhonecentersSysModelQuery.data &&
        <PhonecentersSysModelForm initialValues={getPhonecentersSysModelQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditPhonecentersSysModelProps {
  phonecentersSysModelId: number;
  handleCloseModal: () => void;
}

export default EditPhonecentersSysModel;